/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IAbsoluteChartContainerConfig, IAbsoluteChartContainerProps } from './absolute-chart-container.props.autogenerated';


export interface IAbsoluteChartContainerViewProps extends IAbsoluteChartContainerProps<IAbsoluteChartContainerConfig> {
    row1categories?: React.ReactNode[];
    Row1List: IModuleProps;
    Row1ListItem: INodeProps;
    row2categories?: React.ReactNode[];
    Row2List: IModuleProps;
    Row2ListItem: INodeProps;
    row3categories?: React.ReactNode[];
    Row3List: IModuleProps;
    Row3ListItem: INodeProps;
    row4categories?: React.ReactNode[];
    Row4List: IModuleProps;
    Row4ListItem: INodeProps;
    row5categories?: React.ReactNode[];
    Row5List: IModuleProps;
    Row5ListItem: INodeProps;
    row6categories?: React.ReactNode[];
    Row6List: IModuleProps;
    Row6ListItem: INodeProps;
    row7categories?: React.ReactNode[];
    Row7List: IModuleProps;
    Row7ListItem: INodeProps;
    row8categories?: React.ReactNode[];
    Row8List: IModuleProps;
    Row8ListItem: INodeProps;
    row9categories?: React.ReactNode[];
    Row9List: IModuleProps;
    Row9ListItem: INodeProps;
    row10categories?: React.ReactNode[];
    Row10List: IModuleProps;
    Row10ListItem: INodeProps;
    columnHeading1: string;
    columnHeading2: string;
    columnHeading3: string;
    columnHeading4: string;
    columnHeading5: string;
    
   
}


/**
 *
 * AbsoluteChartContainer component.
 * @extends {React.PureComponent<IAbsoluteChartContainerProps<IAbsoluteChartContainerConfig>>}
 */
 class AbsoluteChartContainer extends React.PureComponent<IAbsoluteChartContainerProps<IAbsoluteChartContainerConfig>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const ColumnHeading1 = config.columnHeading1 ? config.columnHeading1 : '';
        const ColumnHeading2 = config.columnHeading2 ? config.columnHeading2 : '';
        const ColumnHeading3 = config.columnHeading3 ? config.columnHeading3 : '';
        const ColumnHeading4 = config.columnHeading4 ? config.columnHeading4 : '';
        const ColumnHeading5 = config.columnHeading5 ? config.columnHeading5 : '';
        

        if (!this.props.slots || !this.props.slots.row1 || this.props.slots.row1.length === 0) {
            this.props.context.telemetry.error('row1 is empty, module wont render');
            return null;
        }
        if (!this.props.slots || !this.props.slots.row2 || this.props.slots.row2.length === 0) {
            this.props.context.telemetry.error('row2 is empty, module wont render');
            return null;
        }
        if (!this.props.slots || !this.props.slots.row3 || this.props.slots.row3.length === 0) {
            this.props.context.telemetry.error('row3 is empty, module wont render');
            return null;
        }
        if (!this.props.slots || !this.props.slots.row4 || this.props.slots.row4.length === 0) {
            this.props.context.telemetry.error('row4 is empty, module wont render');
            return null;
        }
        if (!this.props.slots || !this.props.slots.row5 || this.props.slots.row5.length === 0) {
            this.props.context.telemetry.error('row5 is empty, module wont render');
            return null;
        }
        if (!this.props.slots || !this.props.slots.row6 || this.props.slots.row6.length === 0) {
            this.props.context.telemetry.error('row6 is empty, module wont render');
            return null;
        }
        if (!this.props.slots || !this.props.slots.row7 || this.props.slots.row7.length === 0) {
            this.props.context.telemetry.error('row7 is empty, module wont render');
            return null;
        }
        if (!this.props.slots || !this.props.slots.row8 || this.props.slots.row8.length === 0) {
            this.props.context.telemetry.error('row8 is empty, module wont render');
            return null;
        }
        if (!this.props.slots || !this.props.slots.row9 || this.props.slots.row9.length === 0) {
            this.props.context.telemetry.error('row9 is empty, module wont render');
            return null;
        }
        if (!this.props.slots || !this.props.slots.row10 || this.props.slots.row10.length === 0) {
            this.props.context.telemetry.error('row10 is empty, module wont render');
            return null;
        }


        const viewprops = {
            ...this.props,

            columnHeading1: ColumnHeading1,
            columnHeading2: ColumnHeading2,
            columnHeading3: ColumnHeading3,
            columnHeading4: ColumnHeading4,
            columnHeading5: ColumnHeading5,
            
            row1categories: this.props.slots.row1,
            Row1List: {
                moduleProps: this.props,
                className: classnames('table-row', this.props.config.className),
                tag: 'tr'
            },
            Row1ListItem: {
                className: classnames('table-row-column', this.props.config.className),
                tag: 'td'
            },
            row2categories: this.props.slots.row2,
            Row2List: {
                moduleProps: this.props,
                className: classnames('table-row', this.props.config.className),
                tag: 'tr'
            },
            Row2ListItem: {
                className: classnames('table-row-column', this.props.config.className),
                tag: 'td'
            },
            row3categories: this.props.slots.row3,
            Row3List: {
                moduleProps: this.props,
                className: classnames('table-row', this.props.config.className),
                tag: 'tr'
            },
            Row3ListItem: {
                className: classnames('table-row-column', this.props.config.className),
                tag: 'td'
            },
            row4categories: this.props.slots.row4,
            Row4List: {
                moduleProps: this.props,
                className: classnames('table-row', this.props.config.className),
                tag: 'tr'
            },
            Row4ListItem: {
                className: classnames('table-row-column', this.props.config.className),
                tag: 'td'
            },
            row5categories: this.props.slots.row5,
            Row5List: {
                moduleProps: this.props,
                className: classnames('table-row', this.props.config.className),
                tag: 'tr'
            },
            Row5ListItem: {
                className: classnames('table-row-column', this.props.config.className),
                tag: 'td'
            },
            row6categories: this.props.slots.row6,
            Row6List: {
                moduleProps: this.props,
                className: classnames('table-row', this.props.config.className),
                tag: 'tr'
            },
            Row6ListItem: {
                className: classnames('table-row-column', this.props.config.className),
                tag: 'td'
            },
            row7categories: this.props.slots.row7,
            Row7List: {
                moduleProps: this.props,
                className: classnames('table-row', this.props.config.className),
                tag: 'tr'
            },
            Row7ListItem: {
                className: classnames('table-row-column', this.props.config.className),
                tag: 'td'
            },
            row8categories: this.props.slots.row8,
            Row8List: {
                moduleProps: this.props,
                className: classnames('table-row', this.props.config.className),
                tag: 'tr'
            },
            Row8ListItem: {
                className: classnames('table-row-column', this.props.config.className),
                tag: 'td'
            },
            row9categories: this.props.slots.row9,
            Row9List: {
                moduleProps: this.props,
                className: classnames('table-row', this.props.config.className),
                tag: 'tr'
            },
            Row9ListItem: {
                className: classnames('table-row-column', this.props.config.className),
                tag: 'td'
            },
            row10categories: this.props.slots.row10,
            Row10List: {
                moduleProps: this.props,
                className: classnames('table-row', this.props.config.className),
                tag: 'tr'
            },
            Row10ListItem: {
                className: classnames('table-row-column', this.props.config.className),
                tag: 'td'
            }
            
        };

        return this.props.renderView(viewprops) as React.ReactElement;
        
    }
}

export default AbsoluteChartContainer;
